export default __webpack_public_path__ + "static/media/main_Image.e3dccd46.png";